import '@/styles/supervisionStatistics.scss';
import React, { useState, useEffect } from 'react';
import { Tabs, Badge, Picker } from 'antd-mobile';
import { getUser } from '@/utils';

import yuanImg from '@/images/supervise/yuanImg.png';
import subjectImg from '@/images/supervise/subjectImg.png';
import teacherImg from '@/images/supervise/teacherImg.png';
import superImg from '@/images/supervise/superImg.png';
import pickerImg from '@/images/supervise/pickerImg.png';
import Cards from '@/components/card';

import {
  supervisor,
  subject,
  grade,
  teacher,
  getSchoolTermPage,
  getSchoolYearPage,
} from '@/services/saas/statistics';

import StatisticsList from './component/statisticsList';

const BaseParam = {
  // sceneCode: '8',
  // tenantId: '000000',
};

function ListWrap(props) {
  return <ul className="supervise-list">{props.children}</ul>;
}
function RTS(props) {
  const row = (rowData, sectionID, rowID) => {
    return <Cards cardlist={rowData} key={rowID} img={yuanImg} />;
  };
  const row2 = (rowData, sectionID, rowID) => {
    return <Cards cardlist={rowData} key={rowID} img={subjectImg} />;
  };
  const row3 = (rowData, sectionID, rowID) => {
    return <Cards title={rowData.realName} cardlist={rowData} key={rowID} img={teacherImg} />;
  };
  const row4 = (rowData, sectionID, rowID) => {
    return (
      <Cards
        type="sup-rate"
        title={rowData.realName}
        cardlist={rowData}
        key={rowID}
        img={superImg}
      />
    );
  };

  // let const state
  const tabs = [
    { title: <Badge>年级</Badge> },
    { title: <Badge>学科</Badge> },
    { title: <Badge>老师</Badge> },
    { title: <Badge>督导员</Badge> },
  ];
  const pageSize = 3;

  const [timers, setTimers] = useState({});
  const [visible, setVisible] = useState(false);
  const [pickerValue, setPickerValue] = useState([]);
  const [yearlist, setYearlist] = useState([]);
  const [yearname, setTearname] = useState('');
  const [tabIndex, setTableIndex] = useState(0);

  const getYear = async function () {
    const { deptId } = getUser() || {};
    const params = {
      yearType: '2',
      schoolId: deptId,
    };
    const respMenu = await getSchoolYearPage(params);
    if (respMenu.success && respMenu.data) {
      const [{ yearName, yearId }] = respMenu.data;
      setTearname(yearName);
      const arr = respMenu.data.map((item) => {
        return {
          label: item.yearName,
          value: item.yearId,
          yearId: item.yearId,
          children: [],
        };
      });
      const result = await Promise.all(arr.map((item) => timePromise(arr, item.yearId)));
      const [[{ value: termId, startTime, endTime }]] = result;
      let timer = {
        startTime,
        endTime,
      };
      setPickerValue([yearId, termId]);
      setTimers(timer);
    }
  };
  const timePromise = async (arr, id) => {
    return new Promise(async (resolve) => {
      const params = {
        current: 1,
        size: -1,
        yearId: id,
      };
      const respMenu = await getSchoolTermPage(params);
      if (respMenu.success && respMenu.data) {
        const att = respMenu.data.records.map((item) => {
          return {
            label: item.termName,
            value: item.termId,
            yearId: item.yearId,
            endTime: item.endTime,
            startTime: item.startTime,
          };
        });

        for (let i = 0; i < arr.length; i++) {
          let pre = arr[i];
          for (let j = 0; j < att.length; j++) {
            let old = att[j];

            if (pre.yearId === old.yearId) {
              arr[i].children.push(old);
            }
          }
        }
        setYearlist(arr);
        resolve(att);
      }
    });
  };

  useEffect(() => {
    getYear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (timers && JSON.stringify(timers) !== '{}') {
    }
  }, [timers]); // eslint-disable-line react-hooks/exhaustive-deps

  const onOk = (v) => {
    const [yearId, termId] = v;
    const obj = {};
    yearlist.forEach((item) => {
      if (item.yearId === yearId) {
        item.children.forEach((_item) => {
          if (_item.value === termId) {
            obj.startTime = _item.startTime;
            obj.endTime = _item.endTime;
          }
        });
      }
    });
    setTimers(obj);
    setVisible(false);
  };
  return (
    <div className="superviseBox">
      <div className="supervisor-statistics">
        <Picker
          cols={2}
          onOk={onOk}
          visible={visible}
          data={yearlist}
          value={pickerValue}
          onChange={(v) => setPickerValue(v)}
          onDismiss={() => setVisible(false)}
        >
          <div className="yearbox">
            <div className="yearPicker" onClick={() => setVisible(true)}>
              <span>{yearname}</span>{' '}
              {yearname && (
                <img
                  style={{ width: '4vw', height: '4vw' }}
                  src={pickerImg}
                  alt="es-lint want to get"
                ></img>
              )}
            </div>
          </div>
        </Picker>
        <Tabs
          tabs={tabs}
          useOnPan={false}
          animated={false}
          swipeable={false}
          initialPage={tabIndex}
          onChange={(tab, index) => {
            setTableIndex(index);
          }}
          onTabClick={(tab, index) => {
            setTableIndex(index);
          }}
        >
          {/* 年级 */}
          <StatisticsList
            param={{
              ...BaseParam,
              // attributeId: '99cecd74f72b533619fc38659dafcb20',
              code: 'grade',
            }}
            timers={timers}
            renderBodyComponent={() => <ListWrap />}
            renderRow={row2}
            pageSize={pageSize}
            func={grade}
          />
          {/* 学科 */}
          <StatisticsList
            param={{
              ...BaseParam,
              // attributeId: '481efd78a3a9527fc6a2904b34a01ec2',
              code: 'subject',
            }}
            timers={timers}
            renderBodyComponent={() => <ListWrap />}
            renderRow={row}
            pageSize={pageSize}
            func={subject}
          />
          {/* 教师 */}
          <StatisticsList
            param={{
              ...BaseParam,
              // attributeId: '99cecd74f72b533619fc38659dafcb20',
              // code: 'subject',
            }}
            timers={timers}
            renderBodyComponent={() => <ListWrap />}
            renderRow={row3}
            pageSize={pageSize}
            func={teacher}
          />
          {/* 督导 */}
          <StatisticsList
            param={{
              ...BaseParam,
              yearId: pickerValue[0],
              termId: pickerValue[1],
            }}
            timers={timers}
            renderBodyComponent={() => <ListWrap />}
            renderRow={row4}
            pageSize={pageSize}
            func={supervisor}
          />
        </Tabs>
      </div>
    </div>
  );
}

export default RTS;
